import { render, staticRenderFns } from "./workflow-type-index.vue?vue&type=template&id=7d986db8&scoped=true"
import script from "./workflow-type-index.vue?vue&type=script&lang=js"
export * from "./workflow-type-index.vue?vue&type=script&lang=js"
import style0 from "./workflow-type-index.vue?vue&type=style&index=0&id=7d986db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d986db8",
  null
  
)

export default component.exports